<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 41"
        :class="customClasses"
    >
        <g fill="#4E869E" fill-rule="evenodd">
            <path d="M6.667 27.073A6.58 6.58 0 0 1 .093 20.5a6.58 6.58 0 0 1 6.574-6.573A6.58 6.58 0 0 1 13.24 20.5a6.58 6.58 0 0 1-6.573 6.573zM33.333 13.74a6.58 6.58 0 0 1-6.573-6.573A6.58 6.58 0 0 1 33.333.593a6.58 6.58 0 0 1 6.574 6.574 6.58 6.58 0 0 1-6.574 6.573zM33.333 40.407a6.58 6.58 0 0 1-6.573-6.574 6.58 6.58 0 0 1 6.573-6.573 6.58 6.58 0 0 1 6.574 6.573 6.58 6.58 0 0 1-6.574 6.574z"></path>
            <path d="M27.985 32.65l-17.164-8.582 1.194-2.385 17.164 8.582-1.194 2.386M12.015 19.317l-1.194-2.385 17.164-8.583 1.194 2.386-17.164 8.582"></path>
        </g>
    </svg>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue'

    export default defineComponent({
        props: {
            size: {
                type: String,
                required: false,
                default: 'small'
            }
        },
        setup(props) {
            const customClasses = ref({
                'icon': true,
                'icon--small': props.size === 'small',
                'icon--medium': props.size === 'medium',
            })

            return {
                customClasses
            }
        }
    })
</script>